export default "__VITE_ASSET__DtKHq_PI__"